import type { RouteIds } from "@tanstack/react-router";
import { useMatches } from "@tanstack/react-router";
import { useMemo } from "react";

import type { routeTree } from "@/routeTree.gen";

export type AllRouteIds = RouteIds<typeof routeTree>;

export const useTypedRouteTabs = <K extends string>({
  tabs,
  fallback,
}: {
  tabs: Partial<Record<NonNullable<AllRouteIds>, K>>;
  fallback: K;
}): K => {
  const matches = useMatches();

  return useMemo(() => {
    const leafMatch = matches.at(-1);

    const sortedEntries = Object.entries(tabs).sort(
      ([a], [b]) => b.length - a.length,
    );

    for (const [routeId, tabKey] of sortedEntries) {
      if (leafMatch?.routeId.startsWith(routeId)) {
        return tabKey;
      }
    }

    return fallback;
  }, [matches, tabs, fallback]);
};
